import useUser from './useUser';

export default function useRestrictedBusinessIds(): string[] {
  const { user } = useUser();
  return user?.restrictedBusinessIds ?? [];
}
